module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.0-253.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.6.0.md
// module id = 695
// module chunks = 264